import { BenefitsLinks } from "./BenefitsLinks"

export const BenefitsLinksRoute = () =>
  (<BenefitsLinks />)